"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ = require("_");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _FormSettings = _interopRequireDefault(require("./FormSettings"));

var _constants = require("settings-ui-sdk/FormSettings/constants");

var _handleActions;

var initialState = new _FormSettings.default({});

function getSetting(settings, key) {
  return (0, _.find)(settings, {
    key: key
  }) || {};
}

function parseSettingsJsonAt(settings, key) {
  try {
    return JSON.parse(getSetting(settings, key).value || '{}');
  } catch (err) {
    return {};
  }
}

function getNewStateFromSettings(settings) {
  var newState = new _FormSettings.default();
  var style = parseSettingsJsonAt(settings, _constants.STYLE_SETTINGS_KEY); // TODO: Remove once keys migrated

  return Object.values(_constants.STYLE_SETTINGS || {}).filter(function (key) {
    return style[key] || style[_constants.NEW_TO_OLD_STYLE_KEYS_MAP[key]];
  }).reduce(function (accumState, key) {
    return accumState.set(key, style[key] || style[_constants.NEW_TO_OLD_STYLE_KEYS_MAP[key]]);
  }, newState.set(_constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED, getSetting(settings, _constants.CREATE_EMAILLESS_CONTACT_KEY).value === 'true'));
}

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchFormSettingsActionType.SUCCESS, function (state, _ref) {
  var settings = _ref.payload.data.settings;
  return getNewStateFromSettings(settings);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateFormSettingsActionType.SUCCESS, function (state, _ref2) {
  var settings = _ref2.payload.data;
  return getNewStateFromSettings(settings);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;